import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../../util/Rest';

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  unlockingUserStatus: null,
};

const slice = createSlice({
  name: 'unLockUser',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    unlockingUser: (state, action) => {
      state.unlockingUserStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ?
        action?.payload?.data?.message :
        action?.payload?.data?.error;
      state.isLoading = false;
    },
    resetStatus: (state, action) => {
      state.addUserStatus = null;
      state.isLoading = false;
      state.passwordStatus = null;
    },
    resetMessage: (state, action) => {
      state.unlockingUserStatus = null;
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.unlockingUserStatus = null;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchStart,
  fetchSuccess,
  fetchError,
  resetMessage,
  resetStatus,
  resetData,
  unlockingUser,
} = slice.actions;

export const lockedUser = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`unlock/account/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(unlockingUser(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};

export const ResetData = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
